// extracted by mini-css-extract-plugin
export default {"distributionOfPCFCon":"DistributionOfProductCarbonFootprint_distributionOfPCFCon__vfIER","distributionChart":"DistributionOfProductCarbonFootprint_distributionChart__mSeAj"};